export default __webpack_public_path__ + "static/media/teli.16de0c47.png";